export default "__VITE_ASSET__CwAiQ_Tr__"